import React from 'react';
import {
    FormGroup,
    Button,
    Badge,
    Row,
    ButtonGroup,
    Col,
} from 'reactstrap';
import * as moment from 'moment';
import { isEqual } from 'lodash-es';
import {
    faUserClock, faArrowUpRightFromSquare, faPenToSquare, faCheck,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from '@s20/components/common/Link';
import { appendTimeZone } from '@s20/common/util/date';
import { getCounty } from '@s20/common/util/location';
import { httpClient } from '@s20/services/httpClient';
import { BaseFormViewModel } from '../common/ViewModel';
import {
    UncontrolledCollapseUnderlineHeader,
    FormLabel,
    onFieldChange,
    onReactSelectChanged,
    FlexStartRow,
    toasty,
    NumericInput,
    Textarea,
} from '../common/forms/FormElements';
import CommonContext, { ApiRoutes, AppNavPaths } from '../Common';
import SlideForm from '../common/forms/SlideForm';
import { handleFormSaveError } from '../common/forms/ValidationError';
import { Can } from '../Can';
import { DispatchResourceSearchParams } from '../dispatch/Dispatch';
import { PayrollStatus, TimesheetEmergencyPayTypes } from '../payroll/Payroll';
import { JobDetails } from '../job/Job';
import { CountyLabel } from '../uscounties/CountyLabel';
import TimePicker from '../common/forms/TimePicker';
import { Block } from '../common/Block';
import { PayrollCalculationEdit } from './PayrollCalculationEdit';

export default class PayrollCalculationSlideout extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        this.formRef = React.createRef();

        const stateBase = {
            originalDetails: '',
            originalAdjustments: JSON.stringify([]),
            payroll: [],
            adjustments: [],
            isPrinting: false,
            current: {},
            edit: new PayrollCalculationEdit(),
            originalEdit: new PayrollCalculationEdit(),
            payValid: true,
            isEditingBasePayRate: false,
            basePayRateSaving: false,
            basePayRateInput: '',
            basePayRateAdjusted: false,
            usCounties: [],
            ...new BaseFormViewModel(),
        };

        this.state = stateBase;
        this.onChange = this.onChange.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.handleSaveError = this.handleSaveError.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.saveWorkOrderNumber = this.saveWorkOrderNumber.bind(this);
    }

    componentDidMount() {
        return this.populateState();
    }

    onChange = onFieldChange;

    onClose = () => {
        const { saving, originalEdit, edit } = { ...this.state };
        if (!saving && !isEqual({ ...originalEdit }, { ...edit })) {
            const confirmed = window.confirm(
                'You have unsaved changes, are you sure you want to leave?',
            );
            if (!confirmed) return;
        }

        this.resetForm();
        this.props.toggleShow(false);
        this.context.setFormOpened(false);
        this.props.onClose();
    };

    onPrint = () => {
        // this.setState({ isPrinting: true });
        httpClient.open(ApiRoutes.report.timesheet(this.state.id), '_self');

        // this.setState({ isPrinting: false });
    };

    onRefresh = () => {
        this.open(this.state.id);
    };

    onSelectChange = onReactSelectChanged;

    onSubmit = async () => {
        this.setState({ saving: true });
        const { edit, payroll } = { ...this.state };
        if (payroll.payrollStatusId == PayrollStatus.Pending) {
            // Shouldnt be allowed to make some null value in start/end but notes required.

            if (edit.notes && edit.notes !== '' && edit.notes.length > 0) {
                const data = {
                    isPayrollChargeType: edit.isPayrollChargeType,
                    currentId: edit.currentId,
                    start: edit.isPayrollChargeType ? null : edit.start,
                    end: edit.isPayrollChargeType ? null : edit.end,
                    quantity: parseFloat(edit.quantity),
                    notes: edit.notes,
                    reg: 0.0,
                    rsd: 0.0,
                    ot: 0.0,
                    otsd: 0.0,
                    t15: 0.0,
                    t15SD: 0.0,
                    emg: 0.0,
                    esd: 0.0,
                    eot: 0.0,
                    eotsd: 0.0,
                    pr: 0.0,
                    prsd: 0.0,
                    vac: 0.0,
                    brv: 0.0,
                    stip: 0.0,
                    hol: 0.0,
                    sck: 0.0,
                    prd: 0.0,
                    pw: 0.0,
                    pwot: 0.0,
                    pwt15: 0.0,
                    dt: 0.0,
                    dtsd: 0.0,
                };

                try {
                    await httpClient.post(
                        ApiRoutes.payrollManagement.edit(),
                        data,
                    );
                    toasty.success('Edit saved.');
                    this.open(payroll.id);
                } catch {
                    toasty.error(
                        'There was an issue saving the edited record.  Please try your request again or contact support for assistance.',
                    );
                } finally {
                    this.setState({ saving: false });
                }
            }
        }

        if (payroll.payrollStatusId == PayrollStatus.Approved) {
            if (
                edit.notes
                && edit.notes !== ''
                && edit.notes.length > 0
                && this.payIsValid(edit) === true
            ) {
                const data = {
                    currentId: edit.currentId,
                    start: '',
                    end: '',
                    quantity: 0.0,
                    reg: parseFloat(edit.reg),
                    rsd: parseFloat(edit.rsd),
                    ot: parseFloat(edit.ot),
                    otsd: parseFloat(edit.otsd),
                    t15: parseFloat(edit.t15),
                    t15SD: parseFloat(edit.t15SD),
                    emg: parseFloat(edit.emg),
                    esd: parseFloat(edit.esd),
                    eot: parseFloat(edit.eot),
                    eotsd: parseFloat(edit.eotsd),
                    pr: parseFloat(edit.pr),
                    prsd: parseFloat(edit.prsd),
                    pw: parseFloat(edit.pw),
                    pwot: parseFloat(edit.pwot),
                    pwt15: parseFloat(edit.pwt15),
                    notes: edit.notes,
                    vac: parseFloat(edit.vac),
                    brv: parseFloat(edit.brv),
                    stip: parseFloat(edit.stip),
                    hol: parseFloat(edit.hol),
                    sck: parseFloat(edit.sck),
                    prd: parseFloat(edit.prd),
                    dt: parseFloat(edit.dt),
                    dtsd: parseFloat(edit.dtsd),
                };

                try {
                    await httpClient.post(ApiRoutes.payroll.edit(), data);
                    toasty.success('Edit saved.');
                    this.open(payroll.id);
                } catch {
                    toasty.error(
                        'There was an issue saving the edited record.  Please try your request again or contact support for assistance.',
                    );
                } finally {
                    this.setState({ saving: false });
                }
            }
        }

        this.resetForm();
        this.setState({ saving: false });
    };

    onTimeEntryChanged = (ev) => {
        const { edit } = { ...this.state };
        const val = ev.target.value;
        const { name } = ev.target;
        // We display the options in 12-hour format, but the db has 24.
        const timeValue = ev.target.value
            ? moment(val, ['h:mm A']).format('HH:mm')
            : '';
        edit[name] = timeValue;
        this.setState({ edit });
        this.setQuantityForEdit();
    };

    setQuantityForEdit = () => {
        const { edit, payroll } = { ...this.state };

        // Calculate the duration between Start and End.  Factor in if this enters into the next day.
        // Use the job start date/time as opposed to moment defaulting to the current day when getting duration.
        if (edit.start && edit.end) {
            const time_format = 'HH:mm';
            const date_format = 'YYYY-MM-DD';
            const mStartDate = moment(payroll.jobStartTimeRaw);
            const mEndDate = moment(payroll.jobEndTimeRaw);

            const mStartTime = moment(edit.start, time_format);
            const mEndTime = moment(edit.end, time_format);
            if (mEndTime.isBefore(mStartTime)) {
                mEndTime.add(1, 'day');
                mEndDate.add(1, 'day');
            }

            const dur = moment.duration(mEndTime.diff(mStartTime));

            edit.startDate = moment(
                `${mStartDate.format(date_format)} ${mStartTime.format(
                    time_format,
                )}`,
            ).valueOf();
            edit.endDate = moment(
                `${mEndDate.format(date_format)} ${mEndTime.format(
                    time_format,
                )}`,
            ).valueOf();
            edit.quantity = dur.asHours().toFixed(2);

            this.setState({ edit });
        }
    };

    handleSaveError = (err) => handleFormSaveError(this, err);

    open = async (payrollId) => {
        // reset adjustments and validation on the way back in.
        this.props.toggleShow(true);
        this.context.setFormOpened(true);
        this.setState({
            loading: true,
            adjustments: [],
            formValidated: false,
        });
        await this.populateState();
        let { edit, originalEdit } = { ...this.state };

        const [payroll] = await Promise.all([
            httpClient.js(ApiRoutes.payrollManagement.slideout(payrollId)),
        ]);

        const params = new DispatchResourceSearchParams();
        params.dispatchLocation = payroll.dispatchCompanyId;

        this.resetForm();

        // apply filter on payroll
        // if (!!this.props.onlyBillable && this.props.onlyBillable === true) {
        //    payroll.payrollCalculations = payroll.payrollCalculations.filter(x => x.isBillable == true);
        // }
        const [current] = payroll.payrollCalculations.filter(
            (x) => x.current == true,
        );

        const overrideRate = (payroll?.overridePayRate > 0 && payroll?.overridePayRate !== payroll?.payRate?.originalPayRate)
            ? payroll.overridePayRate
            : null;

        if (current) {
            edit.currentId = current.id;
            edit.start = current.startRaw;
            edit.end = current.endRaw;
            edit.increment = current.increment;
            edit.quantity = current.quantity;
            edit.isPayrollChargeType = current.isPayrollChargeType;
            if (payroll.payrollStatusId == PayrollStatus.Approved) {
                edit.pay = current.pay;
                edit.reg = current.reg;
                edit.rsd = current.rsd;
                edit.ot = current.ot;
                edit.otsd = current.otsd;
                edit.dt = current.dt;
                edit.dtsd = current.dtsd;
                edit.t15 = current.t15;
                edit.t15SD = current.t15SD;
                edit.emg = current.emg;
                edit.esd = current.esd;
                edit.eot = current.eot;
                edit.eotsd = current.eotsd;
                edit.pr = current.pr;
                edit.prsd = current.prsd;
                edit.pw = current.pw;
                edit.pwot = current.pwot;
                edit.pwt15 = current.pwT15;
                edit.brv = current.brv;
                edit.stip = current.stip;
                edit.hol = current.hol;
                edit.prd = current.prd;
                edit.vac = current.vac;
                edit.sck = current.sck;
            }
            originalEdit = { ...edit };
        }

        this.setState({
            id: payrollId,
            payroll,
            loading: false,
            current,
            originalEdit,
            edit,
            overrideRate,
            // derive base pay numeric and "adjusted" status from backend data
            basePayRateInput: String(
                (overrideRate != null && overrideRate > 0)
                    ? overrideRate
                    : (payroll?.payRate?.payRate ?? ''),
            ),
            basePayRateAdjusted: overrideRate != null,
        });
    };

    saveWorkOrderNumber = async (workOrderNumber) => {
        const { payroll, saving } = this.state;

        // Validation
        if (!workOrderNumber) {
            toasty.error('A work order number is required');

            return false;
        }

        if (!saving) {
            const { timesheetId, timesheetNumber } = payroll;

            this.setState({ saving: true });

            let success = false;

            try {
                const response = await httpClient.put(
                    ApiRoutes.payroll.updateWorkOrderNumber(timesheetId),
                    workOrderNumber,
                    httpClient.format.none,
                );

                success = !!response.ok;
            } catch {
                success = false;
            } finally {
                this.setState({ saving: false });
            }

            if (success) {
                this.onRefresh();

                toasty.success(
                    `[${timesheetNumber}]: Work Order Number Updated.`,
                );
            } else {
                toasty.error(
                    'There was an error updating the work order number. Please try your request again.',
                );
            }
        }
    };

    payIsValid = (edit) => {
        const sum = (parseFloat(edit.reg)
            + parseFloat(edit.rsd)
            + parseFloat(edit.ot)
            + parseFloat(edit.otsd)
            + parseFloat(edit.dt)
            + parseFloat(edit.dtsd)
            + parseFloat(edit.t15)
            + parseFloat(edit.t15SD)
            + parseFloat(edit.emg)
            + parseFloat(edit.esd)
            + parseFloat(edit.eot)
            + parseFloat(edit.eotsd)
            + parseFloat(edit.pr)
            + parseFloat(edit.prsd)
            + parseFloat(edit.pw)
            + parseFloat(edit.pwot)
            + parseFloat(edit.pwt15)
            + parseFloat(edit.brv)
            + parseFloat(edit.vac)
            + parseFloat(edit.hol)
            + parseFloat(edit.sck)
            + parseFloat(edit.prd)
            + parseFloat(edit.stip)
        ).toFixed(2);

        const valid = sum === parseFloat(edit.pay).toFixed(2);

        this.setState({ payValid: valid });

        return valid;
    };

    async populateState() {
        const usCounties = await httpClient.js(ApiRoutes.USCounties.all());
        this.setState({
            edit: new PayrollCalculationEdit(),
            usCounties,
        });
    }

    beginEditBasePayRate = () => {
        const { payroll, overrideRate } = this.state;
        const raw = (overrideRate != null && overrideRate > 0)
            ? overrideRate
            : (payroll?.payRate?.payRate ?? '');
        this.setState({
            isEditingBasePayRate: true,
            basePayRateInput: raw !== '' ? String(raw) : '',
        });
    };

    cancelEditBasePayRate = () => {
        this.setState({ isEditingBasePayRate: false });
    };

    saveBasePayRate = async () => {
        const { id, basePayRateInput } = this.state;
        const parsed = parseFloat(basePayRateInput);
        if (Number.isNaN(parsed)) {
            toasty.error('Please enter a valid numeric base pay rate.');
            return;
        }
        try {
            this.setState({ basePayRateSaving: true });

            await httpClient.put(
                ApiRoutes.payroll.overridePayRate(id, parsed),
            );
            toasty.success('Base pay rate updated.');
            // Re-open to reload payroll calculations with adjusted base rate
            await this.open(id);

            this.setState({
                isEditingBasePayRate: false,
                basePayRateSaving: false,
                basePayRateAdjusted: true,
            });
        } catch {
            this.setState({ basePayRateSaving: false });
            toasty.error('Could not update the base pay rate. Please try again.');
        }
    };

    resetForm = () => {
        this.setState({
            formValidated: false,
        });
    };

    render() {
        const {
            payroll,
            formValidated,
            validationMessage,
            loading,
            saving,
            edit,
            payValid,
        } = this.state;

        const tenantSettings = ((this.context ?? {}).tenant ?? {}).tenantSettings ?? {};

        const jobDetailsHeader = tenantSettings
            && tenantSettings.showContractDescriptionInTimesheetView
            && payroll
            && payroll.jobName
            ? `Job Details - ${payroll.jobName}`
            : 'Job Details';

        const shiftDifferentialEnabled = Boolean(tenantSettings.shiftDifferentialPayAdjustment > 0 || tenantSettings.enableRegularShiftDifferential);
        const doubleTimeEnabled = Boolean(tenantSettings.enableDoubleTimePayroll);
        const quirksDisabled = !tenantSettings.quirksEnabled;
        const emergencyOTEnabled = quirksDisabled && tenantSettings.timesheetEmergencyPayTypeId === TimesheetEmergencyPayTypes.Adjustment;
        const premiumEnabled = Boolean(tenantSettings.enableAlternativePayrollBilling);

        const county = getCounty(this.state.usCounties, {
            usCountyId: payroll.usCounty?.id,
            contractUnionWorkTypeId: payroll.contractUnionWorkTypeId,
        });
        return (
            <SlideForm
                size="col-xl-12 col-md-12 col-xs-12"
                loading={loading || !tenantSettings}
                show={this.props.show}
                id="payrollSlideout"
                formIcon={faUserClock}
                formTitle="Payroll Record"
                ref={this.formRef}
                setIsValidated={(value) => {
                    this.setState({ formValidated: value });
                }}
                isValidated={formValidated}
                className="pb-2 w-100"
                onSubmit={this.onSubmit}
                onClose={this.onClose}
                errors={this.state.errors}
                onClearErrors={this.onClearErrors}
                error={validationMessage}
                readOnly={!!saving}
                fullScreen
            >
                <UncontrolledCollapseUnderlineHeader
                    headerText={jobDetailsHeader}
                >
                    <Row className="align-items-start">
                        <Col xs={8}>
                            <JobDetails
                                enableWorkOrderNumberEditing
                                onInlineWorkOrderNumberSubmit={this.saveWorkOrderNumber}
                                isSelfDispatching={payroll.isSelfDispatching}
                                isNonFlagging={payroll.isNonFlagging}
                                customerName={payroll?.customerName}
                                dispatchOfficeName={payroll?.dispatchOfficeName}
                                foremanName={payroll?.foremanName}
                                jobNotes={payroll?.jobNotes}
                                jobId={payroll?.jobId}
                                projectId={payroll?.projectId}
                                jobNumber={payroll?.jobNumber}
                                jobStartTime={payroll?.jobStartTime ? appendTimeZone(payroll.jobStartTime, payroll.jobStartTimeOffset, payroll.timeZone) : undefined}
                                timesheetId={payroll?.timesheetId}
                                timesheetNumber={payroll?.timesheetNumber}
                                timesheetStatus={payroll?.timesheetStatus}
                                workOrderNumber={payroll?.workOrderNumber}
                                workOrderNumberChanged={payroll?.workOrderNumber !== payroll?.initialWorkOrderNumber}
                                initialWorkOrderNumber={payroll?.initialWorkOrderNumber}
                                permissions={this.context?.permissions}
                                payrollEmergencyEmployee={
                                    payroll?.payrollEmergencyEmployee
                                }
                                isPayrollEmergency={payroll?.isPayrollEmergency}
                                tenantSettings={tenantSettings}
                                isPayroll
                                payrollStatusId={payroll?.payrollStatusId}
                                onRefresh={this.onRefresh}
                                canEmergency={payroll?.canEmergency}
                                isClientCancelled={payroll?.isClientCancelled}
                                jobName={payroll?.jobName}
                            />
                        </Col>

                        <Block
                            component={Col}
                            xs={4}
                            className="mr-3 p-2 details-block"
                        >
                            <FormGroup>
                                <FormLabel
                                    htmlFor="meetingLocation"
                                    label="Meeting Location"
                                    className="bottom-border"
                                />
                                <FlexStartRow>
                                    <span
                                        id="meetingLocation"
                                        name="meetingLocation"
                                    >
                                        {(payroll ?? {}).meetingLocation ?? '-'}
                                    </span>
                                </FlexStartRow>
                            </FormGroup>
                            <FormGroup>
                                <FormLabel
                                    htmlFor="jobLocation"
                                    label="Job Location"
                                    className="bottom-border"
                                />
                                <FlexStartRow>
                                    <span
                                        id="jobLocation"
                                        name="jobLocation"
                                    >
                                        {(payroll ?? {}).jobLocation ?? '-'}
                                    </span>
                                </FlexStartRow>
                            </FormGroup>

                            {Boolean(payroll?.usCounty) && (
                                <FormGroup>
                                    <FormLabel
                                        htmlFor="usCounty"
                                        label="County"
                                        className="bottom-border"
                                    />
                                    <FlexStartRow>
                                        <div>
                                            <CountyLabel {...county} />
                                        </div>
                                    </FlexStartRow>
                                </FormGroup>
                            )}

                            {Boolean(payroll?.paySchedule) && (
                                <FormGroup>
                                    <FormLabel
                                        htmlFor="paySchedule"
                                        label="Pay Schedule"
                                        className="bottom-border"
                                    />
                                    <FlexStartRow>
                                        {payroll.paySchedule.governingBody}

                                        <Can
                                            I="view"
                                            a="contract"
                                        >
                                            <Link
                                                to={`${AppNavPaths.PayScheduleNew}/${payroll.paySchedule.id}`}
                                                target="_blank"
                                                className="ml-1"
                                            >
                                                <FontAwesomeIcon
                                                    icon={faArrowUpRightFromSquare}
                                                    size="sm"
                                                />
                                            </Link>
                                        </Can>
                                    </FlexStartRow>
                                </FormGroup>
                            )}

                            {Boolean(payroll?.payRate) && (
                                <>
                                    <FormGroup>
                                        <FormLabel
                                            label="Employee"
                                            className="bottom-border"
                                        />
                                        <FlexStartRow>
                                            {payroll.employeeName}

                                            <Can
                                                I="edit"
                                                a="employee"
                                            >
                                                <Link
                                                    to={`${AppNavPaths.Employee}/${payroll.employeeId}`}
                                                    target="_blank"
                                                    className="ml-1"
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faArrowUpRightFromSquare}
                                                        size="sm"
                                                    />
                                                </Link>
                                            </Can>
                                        </FlexStartRow>
                                    </FormGroup>

                                    {Boolean(payroll.payRate.payLocalNumber) && (
                                        <>
                                            {payroll.payRate.payLocalNumber !== payroll.payRate.jobLocalNumber ? (
                                                <FormGroup>
                                                    <FormLabel
                                                        label="Employee Local Number"
                                                        className="bottom-border"
                                                    />
                                                    <FlexStartRow>
                                                        {payroll.payRate.payLocalNumber}

                                                        <Can
                                                            I="edit"
                                                            a="county_group"
                                                        >
                                                            <Link
                                                                to={`${AppNavPaths.USCountyGroup}/${payroll.payRate.payUSCountyGroupId}`}
                                                                target="_blank"
                                                                className="ml-1"
                                                            >
                                                                <FontAwesomeIcon
                                                                    icon={faArrowUpRightFromSquare}
                                                                    size="sm"
                                                                />
                                                            </Link>
                                                        </Can>
                                                    </FlexStartRow>
                                                </FormGroup>
                                            ) : (
                                                <FormGroup>
                                                    <FormLabel
                                                        label="Job Local Number"
                                                        className="bottom-border"
                                                    />
                                                    <FlexStartRow>
                                                        {payroll.payRate.payLocalNumber}

                                                        <Can
                                                            I="edit"
                                                            a="county_group"
                                                        >
                                                            <Link
                                                                to={`${AppNavPaths.USCountyGroup}/${payroll.payRate.payUSCountyGroupId}`}
                                                                target="_blank"
                                                                className="ml-1"
                                                            >
                                                                <FontAwesomeIcon
                                                                    icon={faArrowUpRightFromSquare}
                                                                    size="sm"
                                                                />
                                                            </Link>
                                                        </Can>
                                                    </FlexStartRow>
                                                </FormGroup>
                                            )}
                                        </>
                                    )}

                                    {Boolean(payroll.contractScheduleTypeName) && (
                                        <FormGroup>
                                            <FormLabel
                                                label="Union Pay Schedule"
                                                className="bottom-border"
                                            />
                                            <FlexStartRow>
                                                {payroll.contractScheduleTypeName}
                                            </FlexStartRow>
                                        </FormGroup>
                                    )}

                                    <FormGroup>
                                        <FormLabel
                                            label="Base Pay Rate"
                                            className="bottom-border"
                                        />
                                        <FlexStartRow>
                                            {this.state.isEditingBasePayRate ? (
                                                <div style={{ flex: '0 0 18rem', minWidth: '18rem' }}>
                                                    <NumericInput
                                                        step="0.01"
                                                        name="basePayRate"
                                                        value={this.state.basePayRateInput}
                                                        onChange={(e) => this.setState({ basePayRateInput: e.target.value })}
                                                        endAddonContained={false}
                                                        endAddon={(
                                                            <ButtonGroup>
                                                                <Button
                                                                    color="light"
                                                                    onClick={this.cancelEditBasePayRate}
                                                                    disabled={this.state.basePayRateSaving}
                                                                >
                                                                    Cancel
                                                                </Button>
                                                                <Button
                                                                    color="primary"
                                                                    onClick={this.saveBasePayRate}
                                                                    disabled={this.state.basePayRateSaving}
                                                                    className="btn btn-primary d-flex align-items-center"
                                                                >
                                                                    <div className="d-flex align-items-center">
                                                                        <FontAwesomeIcon icon={faCheck} />
                                                                        <span className="ml-2">Save</span>
                                                                    </div>
                                                                </Button>
                                                            </ButtonGroup>
                                                        )}
                                                    />
                                                </div>
                                            ) : (
                                                <>
                                                    {this.state.overrideRate != null && this.state.overrideRate > 0 ? (
                                                        <div className="d-flex flex-column">
                                                            <div className="d-flex align-items-center">
                                                                <span>
                                                                    {this.state.overrideRate.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
                                                                </span>
                                                                <Badge className="p-1 ml-2">ADJ</Badge>

                                                                {quirksDisabled && (
                                                                    <Button
                                                                        color="link"
                                                                        className="p-0 ml-2"
                                                                        aria-label="Edit base pay rate"
                                                                        onClick={this.beginEditBasePayRate}
                                                                    >
                                                                        <FontAwesomeIcon icon={faPenToSquare} />
                                                                    </Button>
                                                                )}
                                                            </div>

                                                            {(payroll?.payRate?.originalPayRateFormatted ?? payroll?.payRate?.payRateFormatted) && (
                                                                <div className="text-muted mt-1">
                                                                    <small>
                                                                        Original: {payroll?.payRate?.originalPayRateFormatted ?? payroll?.payRate?.payRateFormatted}
                                                                    </small>
                                                                </div>
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <span className="d-inline-flex align-items-center">
                                                            {payroll?.payRate?.payRateFormatted ?? '-'}

                                                            {quirksDisabled && (
                                                                <Button
                                                                    color="link"
                                                                    className="p-0 ml-2"
                                                                    aria-label="Edit base pay rate"
                                                                    onClick={this.beginEditBasePayRate}
                                                                >
                                                                    <FontAwesomeIcon icon={faPenToSquare} />
                                                                </Button>
                                                            )}
                                                        </span>
                                                    )}
                                                </>
                                            )}
                                        </FlexStartRow>
                                    </FormGroup>

                                    {payroll.payRate.fringeRate > 0 && (
                                        <FormGroup>
                                            <FormLabel
                                                label="Fringe Rate"
                                                className="bottom-border"
                                            />
                                            <FlexStartRow>
                                                {payroll.payRate.fringeRateFormatted}
                                            </FlexStartRow>
                                        </FormGroup>
                                    )}

                                    {payroll.payRate.incentiveAmount > 0 && (
                                        <FormGroup>
                                            <FormLabel
                                                label="Incentive(s)"
                                                className="bottom-border"
                                            />
                                            <FlexStartRow>
                                                {payroll.payRate.equipmentIncentives.join(', ')}

                                                {' '}

                                                {`(+ ${payroll.payRate.incentiveAmountFormatted})`}
                                            </FlexStartRow>
                                        </FormGroup>
                                    )}

                                    {payroll?.holidayName && (
                                        <FormGroup>
                                            <FormLabel
                                                label="Holiday"
                                                className="bottom-border"
                                            />
                                            <FlexStartRow>
                                                {payroll.holidayName}
                                            </FlexStartRow>
                                        </FormGroup>
                                    )}
                                </>
                            )}
                        </Block>
                    </Row>
                </UncontrolledCollapseUnderlineHeader>

                <UncontrolledCollapseUnderlineHeader
                    headerText="Payroll Records"
                >
                    {((payroll.payrollStatusId ?? {})
                        == PayrollStatus.Approved
                        || (payroll.payrollStatusId ?? {})
                        == PayrollStatus.Pending) && (
                            <FormGroup>
                                <FormLabel
                                    htmlFor="meetingLocation"
                                    label="Edit Current Record"
                                    className="bottom-border"
                                />
                                <FlexStartRow>
                                    {(payroll.payrollStatusId ?? {})
                                        == PayrollStatus.Pending && (
                                            <table className="table table-sm table-bordered table-striped adjustment-table">
                                                <thead className="text-muted">
                                                    <tr>
                                                        <th className="payrollstart">
                                                            Start
                                                        </th>
                                                        <th className="payrollend">
                                                            End
                                                        </th>
                                                        <th className="payrollquantity">
                                                            Quantity
                                                        </th>
                                                        <th className="payrollnote">
                                                            Notes
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr className="adjustments-payroll">
                                                        <td className="payrollstart">
                                                            <TimePicker
                                                                required
                                                                disabled={edit.isPayrollChargeType}
                                                                name="start"
                                                                value={edit.start}
                                                                increment={
                                                                    edit.increment
                                                                }
                                                                onChange={(ev) => this.onTimeEntryChanged(
                                                                    ev,
                                                                )}
                                                            />
                                                        </td>
                                                        <td className="payrollend">
                                                            <TimePicker
                                                                required
                                                                disabled={edit.isPayrollChargeType}
                                                                name="end"
                                                                value={edit.end}
                                                                increment={
                                                                    edit.increment
                                                                }
                                                                onChange={(ev) => this.onTimeEntryChanged(
                                                                    ev,
                                                                )}
                                                            />
                                                        </td>
                                                        {edit.isPayrollChargeType ? (
                                                            <td className="payrollqty">
                                                                <NumericInput
                                                                    required
                                                                    step={edit.increment}
                                                                    name="quantity"
                                                                    value={
                                                                        edit.quantity ?? ''
                                                                    }
                                                                    onChange={(evt) => {
                                                                        const { value } = evt.target;
                                                                        const { edit } = {
                                                                            ...this
                                                                                .state,
                                                                        };
                                                                        edit.quantity = parseFloat(
                                                                            value,
                                                                        ).toFixed(
                                                                            2,
                                                                        );
                                                                        this.setState({
                                                                            edit,
                                                                        });
                                                                    }}
                                                                    onBlur={(evt) => {
                                                                        const { value } = evt.target;
                                                                        const { edit } = {
                                                                            ...this
                                                                                .state,
                                                                        };
                                                                        edit.quantity = parseFloat(
                                                                            value,
                                                                        ).toFixed(
                                                                            2,
                                                                        );
                                                                        this.setState({
                                                                            edit,
                                                                        });
                                                                    }}
                                                                />
                                                            </td>
                                                        ) : (<td className="payrollqty">
                                                            {parseFloat(
                                                                edit.quantity,
                                                            ).toFixed(2)}
                                                        </td>)}

                                                        <td className="payrollnotes">
                                                            <Textarea
                                                                required
                                                                name="notes"
                                                                value={
                                                                    edit.notes
                                                                    ?? ''
                                                                }
                                                                onChange={(
                                                                    evt,
                                                                ) => {
                                                                    const { value } = evt
                                                                        .target;
                                                                    const {
                                                                        edit,
                                                                    } = {
                                                                        ...this
                                                                            .state,
                                                                    };
                                                                    edit.notes = value;
                                                                    this.setState(
                                                                        {
                                                                            edit,
                                                                        },
                                                                    );
                                                                }}
                                                                error="Adjustment notes are required"
                                                            />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        )}
                                    {(payroll.payrollStatusId ?? {})
                                        == PayrollStatus.Approved && (
                                            <table className="table table-sm table-bordered table-striped adjustment-table">
                                                {payroll.isPayrollTimesheet ? (
                                                    <>
                                                        <thead className="text-muted">
                                                            <tr>
                                                                <th className="payrollpay">
                                                                    Pay
                                                                </th>
                                                                <th className="payrollbrv">
                                                                    BRV
                                                                </th>
                                                                <th className="payrollhol">
                                                                    HOL
                                                                </th>
                                                                <th className="payrollsck">
                                                                    SCK
                                                                </th>
                                                                <th className="payrollvac">
                                                                    VAC
                                                                </th>
                                                                <th className="payrollprd">
                                                                    PRD
                                                                </th>
                                                                <th className="payrollstip">
                                                                    STIP
                                                                </th>
                                                                <th className="payrollprd">
                                                                    Notes
                                                                </th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            <tr className="adjustments-payroll">
                                                                <td className="payrollpay">
                                                                    <FormGroup className="mb-0">
                                                                        {parseFloat(
                                                                            edit.pay,
                                                                        ).toFixed(2)}
                                                                        {(!!payValid
                                                                            ?? {})
                                                                            == false && (
                                                                                <small className="text-danger">
                                                                                    Category sum
                                                                                    does not
                                                                                    match the
                                                                                    Pay.
                                                                                </small>
                                                                            )}
                                                                    </FormGroup>
                                                                </td>
                                                                <td className="payrollbrv">
                                                                    <NumericInput
                                                                        required
                                                                        step="0.01"
                                                                        name="brv"
                                                                        value={
                                                                            edit.brv ?? ''
                                                                        }
                                                                        onChange={(evt) => {
                                                                            const { value } = evt.target;
                                                                            const { edit } = {
                                                                                ...this
                                                                                    .state,
                                                                            };
                                                                            edit.brv = value; // parseFloat(value).toFixed(2);
                                                                            this.setState({
                                                                                edit,
                                                                            });
                                                                        }}
                                                                        onBlur={(evt) => {
                                                                            const { value } = evt.target;
                                                                            const { edit } = {
                                                                                ...this
                                                                                    .state,
                                                                            };
                                                                            edit.brv = parseFloat(
                                                                                value,
                                                                            ).toFixed(
                                                                                2,
                                                                            );
                                                                            this.setState({
                                                                                edit,
                                                                            });
                                                                        }}
                                                                    />
                                                                </td>
                                                                <td className="payrollhol">
                                                                    <NumericInput
                                                                        required
                                                                        step="0.01"
                                                                        name="hol"
                                                                        value={
                                                                            edit.hol ?? ''
                                                                        }
                                                                        onChange={(evt) => {
                                                                            const { value } = evt.target;
                                                                            const { edit } = {
                                                                                ...this
                                                                                    .state,
                                                                            };
                                                                            edit.hol = value; // parseFloat(value).toFixed(2);
                                                                            this.setState({
                                                                                edit,
                                                                            });
                                                                        }}
                                                                        onBlur={(evt) => {
                                                                            const { value } = evt.target;
                                                                            const { edit } = {
                                                                                ...this
                                                                                    .state,
                                                                            };
                                                                            edit.hol = parseFloat(
                                                                                value,
                                                                            ).toFixed(
                                                                                2,
                                                                            );
                                                                            this.setState({
                                                                                edit,
                                                                            });
                                                                        }}
                                                                    />
                                                                </td>
                                                                <td className="payrollsck">
                                                                    <NumericInput
                                                                        required
                                                                        step="0.01"
                                                                        name="sck"
                                                                        value={
                                                                            edit.sck ?? ''
                                                                        }
                                                                        onChange={(evt) => {
                                                                            const { value } = evt.target;
                                                                            const { edit } = {
                                                                                ...this
                                                                                    .state,
                                                                            };
                                                                            edit.sck = value; // parseFloat(value).toFixed(2);
                                                                            this.setState({
                                                                                edit,
                                                                            });
                                                                        }}
                                                                        onBlur={(evt) => {
                                                                            const { value } = evt.target;
                                                                            const { edit } = {
                                                                                ...this
                                                                                    .state,
                                                                            };
                                                                            edit.sck = parseFloat(
                                                                                value,
                                                                            ).toFixed(
                                                                                2,
                                                                            );
                                                                            this.setState({
                                                                                edit,
                                                                            });
                                                                        }}
                                                                    />
                                                                </td>
                                                                <td className="payrollvac">
                                                                    <NumericInput
                                                                        required
                                                                        step="0.01"
                                                                        name="vac"
                                                                        value={
                                                                            edit.vac ?? ''
                                                                        }
                                                                        onChange={(evt) => {
                                                                            const { value } = evt.target;
                                                                            const { edit } = {
                                                                                ...this
                                                                                    .state,
                                                                            };
                                                                            edit.vac = value; // parseFloat(value).toFixed(2);
                                                                            this.setState({
                                                                                edit,
                                                                            });
                                                                        }}
                                                                        onBlur={(evt) => {
                                                                            const { value } = evt.target;
                                                                            const { edit } = {
                                                                                ...this
                                                                                    .state,
                                                                            };
                                                                            edit.vac = parseFloat(
                                                                                value,
                                                                            ).toFixed(
                                                                                2,
                                                                            );
                                                                            this.setState({
                                                                                edit,
                                                                            });
                                                                        }}
                                                                    />
                                                                </td>

                                                                <td className="payrollprd">
                                                                    <NumericInput
                                                                        required
                                                                        step="0.01"
                                                                        name="prd"
                                                                        value={
                                                                            edit.prd ?? ''
                                                                        }
                                                                        onChange={(evt) => {
                                                                            const { value } = evt.target;
                                                                            const { edit } = {
                                                                                ...this
                                                                                    .state,
                                                                            };
                                                                            edit.prd = value; // parseFloat(value).toFixed(2);
                                                                            this.setState({
                                                                                edit,
                                                                            });
                                                                        }}
                                                                        onBlur={(evt) => {
                                                                            const { value } = evt.target;
                                                                            const { edit } = {
                                                                                ...this
                                                                                    .state,
                                                                            };
                                                                            edit.prd = parseFloat(
                                                                                value,
                                                                            ).toFixed(
                                                                                2,
                                                                            );
                                                                            this.setState({
                                                                                edit,
                                                                            });
                                                                        }}
                                                                    />
                                                                </td>

                                                                <td className="payrollstip">
                                                                    <NumericInput
                                                                        required
                                                                        step="0.01"
                                                                        name="stip"
                                                                        value={
                                                                            edit.stip ?? ''
                                                                        }
                                                                        onChange={(evt) => {
                                                                            const { value } = evt.target;
                                                                            const { edit } = {
                                                                                ...this
                                                                                    .state,
                                                                            };
                                                                            edit.stip = value; // parseFloat(value).toFixed(2);
                                                                            this.setState({
                                                                                edit,
                                                                            });
                                                                        }}
                                                                        onBlur={(evt) => {
                                                                            const { value } = evt.target;
                                                                            const { edit } = {
                                                                                ...this
                                                                                    .state,
                                                                            };
                                                                            edit.stip = parseFloat(
                                                                                value,
                                                                            ).toFixed(
                                                                                2,
                                                                            );
                                                                            this.setState({
                                                                                edit,
                                                                            });
                                                                        }}
                                                                    />
                                                                </td>

                                                                <td className="payrollnotes">
                                                                    <Textarea
                                                                        required
                                                                        name="notes"
                                                                        value={edit.notes ?? ''}
                                                                        onChange={(
                                                                            evt,
                                                                        ) => {
                                                                            const { value } = evt
                                                                                .target;
                                                                            const {
                                                                                edit,
                                                                            } = {
                                                                                ...this
                                                                                    .state,
                                                                            };
                                                                            edit.notes = value;
                                                                            this.setState(
                                                                                {
                                                                                    edit,
                                                                                },
                                                                            );
                                                                        }}
                                                                        error="Adjustment notes are required."
                                                                    />
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </>
                                                ) : (
                                                    <>
                                                        {edit.isPayrollChargeType ? (
                                                            <>
                                                                <thead className="text-muted">
                                                                    <tr>
                                                                        <th className="payrollpay">
                                                                            Pay
                                                                        </th>
                                                                        <th className="payrollprd">
                                                                            PRD
                                                                        </th>
                                                                        <th className="payrollstip">
                                                                            STIP
                                                                        </th>
                                                                        <th className="payrollnotes">
                                                                            Notes
                                                                        </th>
                                                                    </tr>
                                                                </thead>

                                                                <tbody>
                                                                    <tr className="adjustments-payroll">
                                                                        <td className="payrollpay">
                                                                            <FormGroup className="mb-0">
                                                                                {parseFloat(
                                                                                    edit.pay,
                                                                                ).toFixed(2)}
                                                                                {(!!payValid
                                                                                    ?? {})
                                                                                    == false && (
                                                                                        <small className="text-danger">
                                                                                            Category sum
                                                                                            does not
                                                                                            match the
                                                                                            Pay.
                                                                                        </small>
                                                                                    )}
                                                                            </FormGroup>
                                                                        </td>
                                                                        <td className="payrollprd">
                                                                            <NumericInput
                                                                                required
                                                                                step="0.01"
                                                                                name="prd"
                                                                                value={
                                                                                    edit.prd ?? ''
                                                                                }
                                                                                onChange={(evt) => {
                                                                                    const { value } = evt.target;
                                                                                    const { edit } = {
                                                                                        ...this
                                                                                            .state,
                                                                                    };
                                                                                    edit.prd = value; // parseFloat(value).toFixed(2);
                                                                                    this.setState({
                                                                                        edit,
                                                                                    });
                                                                                }}
                                                                                onBlur={(evt) => {
                                                                                    const { value } = evt.target;
                                                                                    const { edit } = {
                                                                                        ...this
                                                                                            .state,
                                                                                    };
                                                                                    edit.prd = parseFloat(
                                                                                        value,
                                                                                    ).toFixed(
                                                                                        2,
                                                                                    );
                                                                                    this.setState({
                                                                                        edit,
                                                                                    });
                                                                                }}
                                                                            />
                                                                        </td>
                                                                        <td className="payrollstip">
                                                                            <NumericInput
                                                                                required
                                                                                step="0.01"
                                                                                name="stip"
                                                                                value={
                                                                                    edit.stip ?? ''
                                                                                }
                                                                                onChange={(evt) => {
                                                                                    const { value } = evt.target;
                                                                                    const { edit } = {
                                                                                        ...this
                                                                                            .state,
                                                                                    };
                                                                                    edit.stip = value; // parseFloat(value).toFixed(2);
                                                                                    this.setState({
                                                                                        edit,
                                                                                    });
                                                                                }}
                                                                                onBlur={(evt) => {
                                                                                    const { value } = evt.target;
                                                                                    const { edit } = {
                                                                                        ...this
                                                                                            .state,
                                                                                    };
                                                                                    edit.stip = parseFloat(
                                                                                        value,
                                                                                    ).toFixed(
                                                                                        2,
                                                                                    );
                                                                                    this.setState({
                                                                                        edit,
                                                                                    });
                                                                                }}
                                                                            />
                                                                        </td>
                                                                        <td className="payrollnotes">
                                                                            <Textarea
                                                                                required
                                                                                name="notes"
                                                                                value={edit.notes ?? ''}
                                                                                onChange={(
                                                                                    evt,
                                                                                ) => {
                                                                                    const { value } = evt
                                                                                        .target;
                                                                                    const {
                                                                                        edit,
                                                                                    } = {
                                                                                        ...this
                                                                                            .state,
                                                                                    };
                                                                                    edit.notes = value;
                                                                                    this.setState(
                                                                                        {
                                                                                            edit,
                                                                                        },
                                                                                    );
                                                                                }}
                                                                                error="Adjustment notes are required."
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <thead className="text-muted">
                                                                    <tr>
                                                                        <th className="payrollpay">
                                                                            Pay
                                                                        </th>
                                                                        <th className="payrollreg">
                                                                            REG
                                                                        </th>
                                                                        {shiftDifferentialEnabled && (
                                                                            <th className="payrollrsd">
                                                                                RSD
                                                                            </th>
                                                                        )}

                                                                        <th className="payrollot">
                                                                            OT
                                                                        </th>

                                                                        {shiftDifferentialEnabled && (
                                                                            <th className="payrollotsd">
                                                                                OTSD
                                                                            </th>
                                                                        )}

                                                                        <th className="payrollt15">
                                                                            T15
                                                                        </th>

                                                                        {shiftDifferentialEnabled && (
                                                                            <th className="payrollt15SD">
                                                                                T15SD
                                                                            </th>
                                                                        )}

                                                                        {quirksDisabled && (
                                                                            <th className="payrollemg">
                                                                                EMG
                                                                            </th>
                                                                        )}

                                                                        {quirksDisabled && shiftDifferentialEnabled && (
                                                                            <th className="payrollesd">
                                                                                ESD
                                                                            </th>
                                                                        )}

                                                                        {emergencyOTEnabled && (
                                                                            <th className="payrolleot">
                                                                                EOT
                                                                            </th>
                                                                        )}

                                                                        {emergencyOTEnabled && shiftDifferentialEnabled && (
                                                                            <th className="payrollesd">
                                                                                EOTSD
                                                                            </th>
                                                                        )}

                                                                        {premiumEnabled && (
                                                                            <th className="payrollpr">
                                                                                PR
                                                                            </th>
                                                                        )}

                                                                        {premiumEnabled && shiftDifferentialEnabled && (
                                                                            <th className="payrollprsd">
                                                                                PRSD
                                                                            </th>
                                                                        )}

                                                                        {doubleTimeEnabled && (
                                                                            <th className="payrolldt">
                                                                                DT
                                                                            </th>
                                                                        )}

                                                                        {doubleTimeEnabled && shiftDifferentialEnabled && (
                                                                            <th className="payrolldtsd">
                                                                                DTSD
                                                                            </th>
                                                                        )}

                                                                        {Boolean(tenantSettings.enablePrevailingWageContracts) && (
                                                                            <>
                                                                                <th className="payrollpw">
                                                                                    PW
                                                                                </th>

                                                                                <th className="payrollpwot">
                                                                                    PWOT
                                                                                </th>

                                                                                <th className="payrollpwt15">
                                                                                    PWT15
                                                                                </th>
                                                                            </>
                                                                        )}

                                                                        <th className="payrollnote">
                                                                            Notes
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr className="adjustments-payroll">
                                                                        <td className="payrollpay">
                                                                            <FormGroup className="mb-0">
                                                                                {parseFloat(
                                                                                    edit.pay,
                                                                                ).toFixed(2)}
                                                                                {(!!payValid
                                                                                    ?? {})
                                                                                    == false && (
                                                                                        <small className="text-danger">
                                                                                            Category sum
                                                                                            does not
                                                                                            match the
                                                                                            Pay.
                                                                                        </small>
                                                                                    )}
                                                                            </FormGroup>
                                                                        </td>
                                                                        <td className="payrollreg">
                                                                            <NumericInput
                                                                                required
                                                                                step="0.01"
                                                                                name="reg"
                                                                                value={
                                                                                    edit.reg ?? ''
                                                                                }
                                                                                onChange={(evt) => {
                                                                                    const { value } = evt.target;
                                                                                    const { edit } = {
                                                                                        ...this
                                                                                            .state,
                                                                                    };
                                                                                    edit.reg = value; // parseFloat(value).toFixed(2);
                                                                                    this.setState({
                                                                                        edit,
                                                                                    });
                                                                                }}
                                                                                onBlur={(evt) => {
                                                                                    const { value } = evt.target;
                                                                                    const { edit } = {
                                                                                        ...this
                                                                                            .state,
                                                                                    };
                                                                                    edit.reg = parseFloat(
                                                                                        value,
                                                                                    ).toFixed(
                                                                                        2,
                                                                                    );
                                                                                    this.setState({
                                                                                        edit,
                                                                                    });
                                                                                }}
                                                                            />
                                                                        </td>

                                                                        {shiftDifferentialEnabled && (
                                                                            <td className="payrollrsd">
                                                                                <NumericInput
                                                                                    required
                                                                                    step="0.01"
                                                                                    name="rsd"
                                                                                    value={
                                                                                        edit.rsd ?? ''
                                                                                    }
                                                                                    onChange={(evt) => {
                                                                                        const { value } = evt.target;
                                                                                        const { edit } = {
                                                                                            ...this
                                                                                                .state,
                                                                                        };
                                                                                        edit.rsd = value; // parseFloat(value).toFixed(2);
                                                                                        this.setState({
                                                                                            edit,
                                                                                        });
                                                                                    }}
                                                                                    onBlur={(evt) => {
                                                                                        const { value } = evt.target;
                                                                                        const { edit } = {
                                                                                            ...this
                                                                                                .state,
                                                                                        };
                                                                                        edit.rsd = parseFloat(
                                                                                            value,
                                                                                        ).toFixed(
                                                                                            2,
                                                                                        );
                                                                                        this.setState({
                                                                                            edit,
                                                                                        });
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                        )}

                                                                        <td className="payrollot">
                                                                            <NumericInput
                                                                                required
                                                                                step="0.01"
                                                                                name="ot"
                                                                                value={
                                                                                    edit.ot ?? ''
                                                                                }
                                                                                onChange={(evt) => {
                                                                                    const { value } = evt.target;
                                                                                    const { edit } = {
                                                                                        ...this
                                                                                            .state,
                                                                                    };
                                                                                    edit.ot = value; // parseFloat(value).toFixed(2);
                                                                                    this.setState({
                                                                                        edit,
                                                                                    });
                                                                                }}
                                                                                onBlur={(evt) => {
                                                                                    const { value } = evt.target;
                                                                                    const { edit } = {
                                                                                        ...this
                                                                                            .state,
                                                                                    };
                                                                                    edit.ot = parseFloat(
                                                                                        value,
                                                                                    ).toFixed(
                                                                                        2,
                                                                                    );
                                                                                    this.setState({
                                                                                        edit,
                                                                                    });
                                                                                }}
                                                                            />
                                                                        </td>

                                                                        {shiftDifferentialEnabled && (
                                                                            <td className="payrollotsd">
                                                                                <NumericInput
                                                                                    required
                                                                                    step="0.01"
                                                                                    name="otsd"
                                                                                    value={
                                                                                        edit.otsd ?? ''
                                                                                    }
                                                                                    onChange={(evt) => {
                                                                                        const { value } = evt.target;
                                                                                        const { edit } = {
                                                                                            ...this
                                                                                                .state,
                                                                                        };
                                                                                        edit.otsd = value; // parseFloat(value).toFixed(2);
                                                                                        this.setState({
                                                                                            edit,
                                                                                        });
                                                                                    }}
                                                                                    onBlur={(evt) => {
                                                                                        const { value } = evt.target;
                                                                                        const { edit } = {
                                                                                            ...this
                                                                                                .state,
                                                                                        };
                                                                                        edit.otsd = parseFloat(
                                                                                            value,
                                                                                        ).toFixed(
                                                                                            2,
                                                                                        );
                                                                                        this.setState({
                                                                                            edit,
                                                                                        });
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                        )}

                                                                        <td className="payrollt15">
                                                                            <NumericInput
                                                                                required
                                                                                step="0.01"
                                                                                name="t15"
                                                                                value={
                                                                                    edit.t15 ?? ''
                                                                                }
                                                                                onChange={(evt) => {
                                                                                    const { value } = evt.target;
                                                                                    const { edit } = {
                                                                                        ...this
                                                                                            .state,
                                                                                    };
                                                                                    edit.t15 = value; // parseFloat(value).toFixed(2);
                                                                                    this.setState({
                                                                                        edit,
                                                                                    });
                                                                                }}
                                                                                onBlur={(evt) => {
                                                                                    const { value } = evt.target;
                                                                                    const { edit } = {
                                                                                        ...this
                                                                                            .state,
                                                                                    };
                                                                                    edit.t15 = parseFloat(
                                                                                        value,
                                                                                    ).toFixed(
                                                                                        2,
                                                                                    );
                                                                                    this.setState({
                                                                                        edit,
                                                                                    });
                                                                                }}
                                                                            />
                                                                        </td>

                                                                        {shiftDifferentialEnabled && (
                                                                            <td className="payrollt15SD">
                                                                                <NumericInput
                                                                                    required
                                                                                    step="0.01"
                                                                                    name="t15SD"
                                                                                    value={
                                                                                        edit.t15SD ?? ''
                                                                                    }
                                                                                    onChange={(evt) => {
                                                                                        const { value } = evt.target;
                                                                                        const { edit } = {
                                                                                            ...this
                                                                                                .state,
                                                                                        };
                                                                                        edit.t15SD = value; // parseFloat(value).toFixed(2);
                                                                                        this.setState({
                                                                                            edit,
                                                                                        });
                                                                                    }}
                                                                                    onBlur={(evt) => {
                                                                                        const { value } = evt.target;
                                                                                        const { edit } = {
                                                                                            ...this
                                                                                                .state,
                                                                                        };
                                                                                        edit.t15SD = parseFloat(
                                                                                            value,
                                                                                        ).toFixed(
                                                                                            2,
                                                                                        );
                                                                                        this.setState({
                                                                                            edit,
                                                                                        });
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                        )}

                                                                        {quirksDisabled && (
                                                                            <td className="payrollemg">
                                                                                <NumericInput
                                                                                    required
                                                                                    step="0.01"
                                                                                    name="emg"
                                                                                    value={
                                                                                        edit.emg ?? ''
                                                                                    }
                                                                                    onChange={(evt) => {
                                                                                        const { value } = evt.target;
                                                                                        const { edit } = {
                                                                                            ...this
                                                                                                .state,
                                                                                        };
                                                                                        edit.emg = value; // parseFloat(value).toFixed(2);
                                                                                        this.setState({
                                                                                            edit,
                                                                                        });
                                                                                    }}
                                                                                    onBlur={(evt) => {
                                                                                        const { value } = evt.target;
                                                                                        const { edit } = {
                                                                                            ...this
                                                                                                .state,
                                                                                        };
                                                                                        edit.emg = parseFloat(
                                                                                            value,
                                                                                        ).toFixed(
                                                                                            2,
                                                                                        );
                                                                                        this.setState({
                                                                                            edit,
                                                                                        });
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                        )}

                                                                        {quirksDisabled && shiftDifferentialEnabled && (
                                                                            <td className="payrollesd">
                                                                                <NumericInput
                                                                                    required
                                                                                    step="0.01"
                                                                                    name="esd"
                                                                                    value={
                                                                                        edit.esd ?? ''
                                                                                    }
                                                                                    onChange={(evt) => {
                                                                                        const { value } = evt.target;
                                                                                        const { edit } = {
                                                                                            ...this
                                                                                                .state,
                                                                                        };
                                                                                        edit.esd = value; // parseFloat(value).toFixed(2);
                                                                                        this.setState({
                                                                                            edit,
                                                                                        });
                                                                                    }}
                                                                                    onBlur={(evt) => {
                                                                                        const { value } = evt.target;
                                                                                        const { edit } = {
                                                                                            ...this
                                                                                                .state,
                                                                                        };
                                                                                        edit.esd = parseFloat(
                                                                                            value,
                                                                                        ).toFixed(
                                                                                            2,
                                                                                        );
                                                                                        this.setState({
                                                                                            edit,
                                                                                        });
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                        )}

                                                                        {emergencyOTEnabled && (
                                                                            <td className="payrolleot">
                                                                                <NumericInput
                                                                                    required
                                                                                    step="0.01"
                                                                                    name="eot"
                                                                                    value={
                                                                                        edit.eot ?? ''
                                                                                    }
                                                                                    onChange={(evt) => {
                                                                                        const { value } = evt.target;
                                                                                        const { edit } = {
                                                                                            ...this
                                                                                                .state,
                                                                                        };
                                                                                        edit.eot = value; // parseFloat(value).toFixed(2);
                                                                                        this.setState({
                                                                                            edit,
                                                                                        });
                                                                                    }}
                                                                                    onBlur={(evt) => {
                                                                                        const { value } = evt.target;
                                                                                        const { edit } = {
                                                                                            ...this
                                                                                                .state,
                                                                                        };
                                                                                        edit.eot = parseFloat(
                                                                                            value,
                                                                                        ).toFixed(
                                                                                            2,
                                                                                        );
                                                                                        this.setState({
                                                                                            edit,
                                                                                        });
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                        )}

                                                                        {emergencyOTEnabled && shiftDifferentialEnabled && (
                                                                            <td className="payrolleotsd">
                                                                                <NumericInput
                                                                                    required
                                                                                    step="0.01"
                                                                                    name="eotsd"
                                                                                    value={
                                                                                        edit.eotsd ?? ''
                                                                                    }
                                                                                    onChange={(evt) => {
                                                                                        const { value } = evt.target;
                                                                                        const { edit } = {
                                                                                            ...this
                                                                                                .state,
                                                                                        };
                                                                                        edit.eotsd = value; // parseFloat(value).toFixed(2);
                                                                                        this.setState({
                                                                                            edit,
                                                                                        });
                                                                                    }}
                                                                                    onBlur={(evt) => {
                                                                                        const { value } = evt.target;
                                                                                        const { edit } = {
                                                                                            ...this
                                                                                                .state,
                                                                                        };
                                                                                        edit.eotsd = parseFloat(
                                                                                            value,
                                                                                        ).toFixed(
                                                                                            2,
                                                                                        );
                                                                                        this.setState({
                                                                                            edit,
                                                                                        });
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                        )}

                                                                        {premiumEnabled && (
                                                                            <td className="payrollpr">
                                                                                <NumericInput
                                                                                    required
                                                                                    step="0.01"
                                                                                    name="pr"
                                                                                    value={
                                                                                        edit.pr ?? ''
                                                                                    }
                                                                                    onChange={(evt) => {
                                                                                        const { value } = evt.target;
                                                                                        const { edit } = {
                                                                                            ...this
                                                                                                .state,
                                                                                        };
                                                                                        edit.pr = value; // parseFloat(value).toFixed(2);
                                                                                        this.setState({
                                                                                            edit,
                                                                                        });
                                                                                    }}
                                                                                    onBlur={(evt) => {
                                                                                        const { value } = evt.target;
                                                                                        const { edit } = {
                                                                                            ...this
                                                                                                .state,
                                                                                        };
                                                                                        edit.pr = parseFloat(
                                                                                            value,
                                                                                        ).toFixed(
                                                                                            2,
                                                                                        );
                                                                                        this.setState({
                                                                                            edit,
                                                                                        });
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                        )}

                                                                        {premiumEnabled && shiftDifferentialEnabled && (
                                                                            <td className="payrollprsd">
                                                                                <NumericInput
                                                                                    required
                                                                                    step="0.01"
                                                                                    name="prsd"
                                                                                    value={
                                                                                        edit.prsd ?? ''
                                                                                    }
                                                                                    onChange={(evt) => {
                                                                                        const { value } = evt.target;
                                                                                        const { edit } = {
                                                                                            ...this
                                                                                                .state,
                                                                                        };
                                                                                        edit.prsd = value; // parseFloat(value).toFixed(2);
                                                                                        this.setState({
                                                                                            edit,
                                                                                        });
                                                                                    }}
                                                                                    onBlur={(evt) => {
                                                                                        const { value } = evt.target;
                                                                                        const { edit } = {
                                                                                            ...this
                                                                                                .state,
                                                                                        };
                                                                                        edit.prsd = parseFloat(
                                                                                            value,
                                                                                        ).toFixed(
                                                                                            2,
                                                                                        );
                                                                                        this.setState({
                                                                                            edit,
                                                                                        });
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                        )}

                                                                        {doubleTimeEnabled && (
                                                                            <td className="payrolldt">
                                                                                <NumericInput
                                                                                    required
                                                                                    step="0.01"
                                                                                    name="dt"
                                                                                    value={
                                                                                        edit.dt ?? ''
                                                                                    }
                                                                                    onChange={(evt) => {
                                                                                        const { value } = evt.target;
                                                                                        const { edit } = {
                                                                                            ...this
                                                                                                .state,
                                                                                        };
                                                                                        edit.dt = value; // parseFloat(value).toFixed(2);
                                                                                        this.setState({
                                                                                            edit,
                                                                                        });
                                                                                    }}
                                                                                    onBlur={(evt) => {
                                                                                        const { value } = evt.target;
                                                                                        const { edit } = {
                                                                                            ...this
                                                                                                .state,
                                                                                        };
                                                                                        edit.dt = parseFloat(
                                                                                            value,
                                                                                        ).toFixed(
                                                                                            2,
                                                                                        );
                                                                                        this.setState({
                                                                                            edit,
                                                                                        });
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                        )}

                                                                        {doubleTimeEnabled && shiftDifferentialEnabled && (
                                                                            <td className="payrolldtsd">
                                                                                <NumericInput
                                                                                    required
                                                                                    step="0.01"
                                                                                    name="dtsd"
                                                                                    value={
                                                                                        edit.dtsd ?? ''
                                                                                    }
                                                                                    onChange={(evt) => {
                                                                                        const { value } = evt.target;
                                                                                        const { edit } = {
                                                                                            ...this
                                                                                                .state,
                                                                                        };
                                                                                        edit.dtsd = value; // parseFloat(value).toFixed(2);
                                                                                        this.setState({
                                                                                            edit,
                                                                                        });
                                                                                    }}
                                                                                    onBlur={(evt) => {
                                                                                        const { value } = evt.target;
                                                                                        const { edit } = {
                                                                                            ...this
                                                                                                .state,
                                                                                        };
                                                                                        edit.dtsd = parseFloat(
                                                                                            value,
                                                                                        ).toFixed(
                                                                                            2,
                                                                                        );
                                                                                        this.setState({
                                                                                            edit,
                                                                                        });
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                        )}

                                                                        {Boolean(tenantSettings.enablePrevailingWageContracts) && (
                                                                            <>
                                                                                <td className="payrollpw">
                                                                                    <NumericInput
                                                                                        required
                                                                                        step="0.01"
                                                                                        name="pw"
                                                                                        value={
                                                                                            edit.pw ?? ''
                                                                                        }
                                                                                        onChange={(evt) => {
                                                                                            const { value } = evt.target;
                                                                                            const { edit } = {
                                                                                                ...this
                                                                                                    .state,
                                                                                            };
                                                                                            edit.pw = value; // parseFloat(value).toFixed(2);
                                                                                            this.setState({
                                                                                                edit,
                                                                                            });
                                                                                        }}
                                                                                        onBlur={(evt) => {
                                                                                            const { value } = evt.target;
                                                                                            const { edit } = {
                                                                                                ...this
                                                                                                    .state,
                                                                                            };
                                                                                            edit.pw = parseFloat(
                                                                                                value,
                                                                                            ).toFixed(
                                                                                                2,
                                                                                            );
                                                                                            this.setState({
                                                                                                edit,
                                                                                            });
                                                                                        }}
                                                                                    />
                                                                                </td>

                                                                                <td className="payrollpwot">
                                                                                    <NumericInput
                                                                                        required
                                                                                        step="0.01"
                                                                                        name="pwot"
                                                                                        value={
                                                                                            edit.pwot ?? ''
                                                                                        }
                                                                                        onChange={(evt) => {
                                                                                            const { value } = evt.target;
                                                                                            const { edit } = {
                                                                                                ...this
                                                                                                    .state,
                                                                                            };
                                                                                            edit.pwot = value; // parseFloat(value).toFixed(2);
                                                                                            this.setState({
                                                                                                edit,
                                                                                            });
                                                                                        }}
                                                                                        onBlur={(evt) => {
                                                                                            const { value } = evt.target;
                                                                                            const { edit } = {
                                                                                                ...this
                                                                                                    .state,
                                                                                            };
                                                                                            edit.pwot = parseFloat(
                                                                                                value,
                                                                                            ).toFixed(
                                                                                                2,
                                                                                            );
                                                                                            this.setState({
                                                                                                edit,
                                                                                            });
                                                                                        }}
                                                                                    />
                                                                                </td>

                                                                                <td className="payrollpwt15">
                                                                                    <NumericInput
                                                                                        required
                                                                                        step="0.01"
                                                                                        name="pwt15"
                                                                                        value={edit.pwt15 ?? ''}
                                                                                        onChange={(evt) => {
                                                                                            const { value } = evt.target;
                                                                                            const { edit } = {
                                                                                                ...this
                                                                                                    .state,
                                                                                            };
                                                                                            edit.pwt15 = value; // parseFloat(value).toFixed(2);
                                                                                            this.setState({
                                                                                                edit,
                                                                                            });
                                                                                        }}
                                                                                        onBlur={(evt) => {
                                                                                            const { value } = evt.target;
                                                                                            const { edit } = {
                                                                                                ...this
                                                                                                    .state,
                                                                                            };
                                                                                            edit.pwt15 = parseFloat(
                                                                                                value,
                                                                                            ).toFixed(
                                                                                                2,
                                                                                            );
                                                                                            this.setState({
                                                                                                edit,
                                                                                            });
                                                                                        }}
                                                                                    />
                                                                                </td>
                                                                            </>
                                                                        )}

                                                                        <td className="payrollnotes">
                                                                            <Textarea
                                                                                required
                                                                                name="notes"
                                                                                value={edit.notes ?? ''}
                                                                                onChange={(
                                                                                    evt,
                                                                                ) => {
                                                                                    const { value } = evt
                                                                                        .target;
                                                                                    const {
                                                                                        edit,
                                                                                    } = {
                                                                                        ...this
                                                                                            .state,
                                                                                    };
                                                                                    edit.notes = value;
                                                                                    this.setState(
                                                                                        {
                                                                                            edit,
                                                                                        },
                                                                                    );
                                                                                }}
                                                                                error="Adjustment notes are required."
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </>
                                                        )}
                                                    </>
                                                )}

                                            </table>
                                        )}
                                </FlexStartRow>
                            </FormGroup>
                        )}
                    <div className="payroll">
                        <FormLabel
                            htmlFor="meetingLocation"
                            label="History"
                            className="bottom-border"
                        />
                        {(payroll.payrollStatusId ?? {})
                            == PayrollStatus.Pending && (
                                <table className="table table-sm table-bordered table-striped payroll-table">
                                    <thead className="text-muted">
                                        <tr>
                                            {!!tenantSettings.timesheetAdjustmentsEnabled && (
                                                <th className="isadjusted" />
                                            )}
                                            <th className="payrollcharge">
                                                Charge
                                            </th>
                                            <th className="payrollname">
                                                Name
                                            </th>
                                            <th className="payrollnote">
                                                Notes
                                            </th>
                                            <th className="payrollstart">
                                                Start
                                            </th>
                                            <th className="payrollend">End</th>
                                            <th className="payrollqty">
                                                Quantity
                                            </th>
                                            <th className="payrollunits">
                                                Units
                                            </th>
                                            <th className="payrollbillable">
                                                Billable
                                            </th>
                                            <th className="payrollbreak">
                                                Break
                                            </th>
                                            <th className="payrollCurrent">
                                                Current
                                            </th>
                                            {!!tenantSettings.timesheetAdjustmentsEnabled && (
                                                <Can
                                                    do="accept"
                                                    on="timesheet"
                                                >
                                                    <th className="payrolldelete" />
                                                </Can>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {!(payroll.payrollCalculations ?? []).length ? (
                                            <tr>
                                                <td
                                                    colSpan="5"
                                                    className="text-center"
                                                >
                                                    No payroll found.
                                                </td>
                                            </tr>
                                        ) : (
                                            payroll.payrollCalculations.map(
                                                (detail) => (
                                                    <tr
                                                        key={detail.id}
                                                        className={`timesheet-payroll-table-row${detail.removed
                                                            ? ' strikeout'
                                                            : ''
                                                            }`}
                                                    >
                                                        {!!tenantSettings.timesheetAdjustmentsEnabled && (
                                                            <td className="isadjusted">
                                                                {!!detail.isAdjustment && (
                                                                    <Badge className="p-1">
                                                                        ADJ
                                                                    </Badge>
                                                                )}
                                                            </td>
                                                        )}
                                                        <td className="payrollcharge">
                                                            {
                                                                detail.chargeTypeName
                                                            }
                                                        </td>
                                                        <td className="payrollname">
                                                            {
                                                                detail.employeeName
                                                            }
                                                        </td>
                                                        <td className="payrollnote">
                                                            {!!detail.note && (
                                                                <div className="userNote">
                                                                    <div className="noteContent">
                                                                        {
                                                                            detail.note
                                                                        }
                                                                    </div>
                                                                    <div className="noteContentByLine">
                                                                        {`${detail.noteAuthor}, ${moment.utc(detail.noteAdjustedOn).local().fromNow()}`}                                           </div>
                                                                </div>
                                                            )}
                                                        </td>
                                                        <td className="payrollstart">
                                                            {detail.start}
                                                        </td>
                                                        <td className="payrollend">
                                                            {detail.end}
                                                        </td>
                                                        <td className="payrollqty">
                                                            {parseFloat(
                                                                detail.quantity,
                                                            ).toFixed(2)}
                                                        </td>
                                                        <td className="payrollunits">
                                                            {
                                                                detail.unitsName
                                                            }
                                                        </td>
                                                        <td className="payrollbillable">
                                                            {
                                                                detail.billable
                                                            }
                                                        </td>
                                                        <td className="payrollbreak">
                                                            {Boolean(detail.isBreak) && (
                                                                <>
                                                                    {detail.isPaidBreak
                                                                        ? 'Paid'
                                                                        : 'Unpaid'}
                                                                </>
                                                            )}
                                                        </td>
                                                        <td className="payrollcurrent">
                                                            {detail.current
                                                                ? 'Yes'
                                                                : 'No'}
                                                        </td>
                                                    </tr>
                                                ),
                                            )
                                        )}
                                    </tbody>
                                </table>
                            )}
                        {((payroll.payrollStatusId ?? {})
                            == PayrollStatus.Approved
                            || (payroll.payrollStatusId ?? {})
                            == PayrollStatus.Exported) && (
                                <table className="table table-sm table-bordered table-striped payroll-table">
                                    {payroll.isPayrollTimesheet ? (
                                        <>
                                            <thead className="text-muted">
                                                <tr>
                                                    {!!tenantSettings.timesheetAdjustmentsEnabled && (
                                                        <th className="isadjusted" />
                                                    )}
                                                    <th className="payrollcharge">
                                                        Charge
                                                    </th>
                                                    <th className="payrollname">
                                                        Name
                                                    </th>
                                                    <th className="payrollnote">
                                                        Notes
                                                    </th>
                                                    <th className="payrollcharge">
                                                        Charge
                                                    </th>
                                                    <th className="payrollpay">Pay</th>
                                                    <th className="payrollbrv">BRV</th>
                                                    <th className="payrollhol">HOL</th>
                                                    <th className="payrollsck">SCK</th>
                                                    <th className="payrollvac">VAC</th>
                                                    <th className="payrollvac">PRD</th>
                                                    <th className="payrollstip">STIP</th>
                                                    <th className="payrollCurrent">
                                                        Current
                                                    </th>
                                                    {!!tenantSettings.timesheetAdjustmentsEnabled && (
                                                        <Can
                                                            do="accept"
                                                            on="timesheet"
                                                        >
                                                            <th className="payrolldelete" />
                                                        </Can>
                                                    )}
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {!(payroll.payrollCalculations ?? []).length ? (
                                                    <tr>
                                                        <td
                                                            colSpan="5"
                                                            className="text-center"
                                                        >
                                                            No payroll found.
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    payroll.payrollCalculations.map(
                                                        (detail) => (
                                                            <tr
                                                                key={detail.id}
                                                                className={`timesheet-payroll-table-row${detail.removed
                                                                    ? ' strikeout'
                                                                    : ''
                                                                    }`}
                                                            >
                                                                {!!tenantSettings.timesheetAdjustmentsEnabled && (
                                                                    <td className="isadjusted">
                                                                        {!!detail.isAdjustment && (
                                                                            <Badge className="p-1">
                                                                                ADJ
                                                                            </Badge>
                                                                        )}
                                                                    </td>
                                                                )}
                                                                <td className="payrollcharge">
                                                                    {
                                                                        detail.chargeTypeName
                                                                    }
                                                                </td>
                                                                <td className="payrollname">
                                                                    {
                                                                        detail.employeeName
                                                                    }
                                                                </td>
                                                                <td className="payrollnote">
                                                                    {!!detail.note && (
                                                                        <div className="userNote">
                                                                            <div className="noteContent">
                                                                                {
                                                                                    detail.note
                                                                                }
                                                                            </div>
                                                                            <div className="noteContentByLine">
                                                                                {`${detail.noteAuthor}, ${moment.utc(detail.noteAdjustedOn).local().fromNow()}`}
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </td>
                                                                <td className="payrollcharge">
                                                                    {parseFloat(
                                                                        detail.charge,
                                                                    ).toFixed(2)}
                                                                </td>
                                                                <td className="payrollpay">
                                                                    {parseFloat(
                                                                        detail.pay,
                                                                    ).toFixed(2)}
                                                                </td>
                                                                <td className="payrollbrv">
                                                                    {parseFloat(
                                                                        detail.brv,
                                                                    ).toFixed(2)}
                                                                </td>
                                                                <td className="payrollhol">
                                                                    {parseFloat(
                                                                        detail.hol,
                                                                    ).toFixed(2)}
                                                                </td>
                                                                <td className="payrollsck">
                                                                    {parseFloat(
                                                                        detail.sck,
                                                                    ).toFixed(2)}
                                                                </td>
                                                                <td className="payrollvac">
                                                                    {parseFloat(
                                                                        detail.vac,
                                                                    ).toFixed(2)}
                                                                </td>
                                                                <td className="payrollprd">
                                                                    {parseFloat(
                                                                        detail.prd,
                                                                    ).toFixed(2)}
                                                                </td>

                                                                <td className="payrollstip">
                                                                    {parseFloat(
                                                                        detail.stip,
                                                                    ).toFixed(2)}
                                                                </td>

                                                                <td className="payrollcurrent">
                                                                    {detail.current
                                                                        ? 'Yes'
                                                                        : 'No'}
                                                                </td>
                                                            </tr>
                                                        ),
                                                    )
                                                )}
                                            </tbody>
                                        </>
                                    ) : (
                                        <>
                                            {edit.isPayrollChargeType ? (
                                                <>
                                                    <thead className="text-muted">
                                                        <tr>
                                                            {!!tenantSettings.timesheetAdjustmentsEnabled && (
                                                                <th className="isadjusted" />
                                                            )}
                                                            <th className="payrollcharge">
                                                                Charge
                                                            </th>
                                                            <th className="payrollname">
                                                                Name
                                                            </th>
                                                            <th className="payrollnote">
                                                                Notes
                                                            </th>
                                                            <th className="payrollcharge">
                                                                Charge
                                                            </th>
                                                            <th className="payrollpay">Pay</th>
                                                            <th className="payrollprd">PRD</th>
                                                            <th className="payrollstip">STIP</th>
                                                            <th className="payrollCurrent">
                                                                Current
                                                            </th>
                                                            {!!tenantSettings.timesheetAdjustmentsEnabled && (
                                                                <Can
                                                                    do="accept"
                                                                    on="timesheet"
                                                                >
                                                                    <th className="payrolldelete" />
                                                                </Can>
                                                            )}
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {!(payroll.payrollCalculations ?? []).length ? (
                                                            <tr>
                                                                <td
                                                                    colSpan="5"
                                                                    className="text-center"
                                                                >
                                                                    No payroll found.
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            payroll.payrollCalculations.map(
                                                                (detail) => (
                                                                    <tr
                                                                        key={detail.id}
                                                                        className={`timesheet-payroll-table-row${detail.removed
                                                                            ? ' strikeout'
                                                                            : ''
                                                                            }`}
                                                                    >
                                                                        {!!tenantSettings.timesheetAdjustmentsEnabled && (
                                                                            <td className="isadjusted">
                                                                                {!!detail.isAdjustment && (
                                                                                    <Badge className="p-1">
                                                                                        ADJ
                                                                                    </Badge>
                                                                                )}
                                                                            </td>
                                                                        )}
                                                                        <td className="payrollcharge">
                                                                            {
                                                                                detail.chargeTypeName
                                                                            }
                                                                        </td>
                                                                        <td className="payrollname">
                                                                            {
                                                                                detail.employeeName
                                                                            }
                                                                        </td>
                                                                        <td className="payrollnote">
                                                                            {!!detail.note && (
                                                                                <div className="userNote">
                                                                                    <div className="noteContent">
                                                                                        {
                                                                                            detail.note
                                                                                        }
                                                                                    </div>
                                                                                    <div className="noteContentByLine">
                                                                                        {`${detail.noteAuthor}, ${moment.utc(detail.noteAdjustedOn).local().fromNow()}`}
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </td>
                                                                        <td className="payrollcharge">
                                                                            {parseFloat(
                                                                                detail.charge,
                                                                            ).toFixed(2)}
                                                                        </td>
                                                                        <td className="payrollpay">
                                                                            {parseFloat(
                                                                                detail.pay,
                                                                            ).toFixed(2)}
                                                                        </td>
                                                                        <td className="payrollprd">
                                                                            {parseFloat(
                                                                                detail.prd,
                                                                            ).toFixed(2)}
                                                                        </td>

                                                                        <td className="payrollstip">
                                                                            {parseFloat(
                                                                                detail.stip,
                                                                            ).toFixed(2)}
                                                                        </td>

                                                                        <td className="payrollcurrent">
                                                                            {detail.current
                                                                                ? 'Yes'
                                                                                : 'No'}
                                                                        </td>
                                                                    </tr>
                                                                ),
                                                            )
                                                        )}
                                                    </tbody>
                                                </>
                                            ) : (
                                                <>
                                                    <thead className="text-muted">
                                                        <tr>
                                                            {!!tenantSettings.timesheetAdjustmentsEnabled && (
                                                                <th className="isadjusted" />
                                                            )}
                                                            <th className="payrollcharge">
                                                                Charge
                                                            </th>
                                                            <th className="payrollname">
                                                                Name
                                                            </th>
                                                            <th className="payrollnote">
                                                                Notes
                                                            </th>
                                                            <th className="payrollcharge">
                                                                Charge
                                                            </th>
                                                            <th className="payrollpay">Pay</th>

                                                            <th className="payrollreg">REG</th>
                                                            {shiftDifferentialEnabled && <th className="payrollrsd">RSD</th>}

                                                            <th className="payrollot">OT</th>
                                                            {shiftDifferentialEnabled && <th className="payrollotsd">OTSD</th>}

                                                            <th className="payrollt15">T15</th>
                                                            {shiftDifferentialEnabled && <th className="payrollt15SD">T15SD</th>}

                                                            {quirksDisabled && <th className="payrollemg">EMG</th>}
                                                            {quirksDisabled && shiftDifferentialEnabled && <th className="payrollesd">ESD</th>}

                                                            {emergencyOTEnabled && <th className="payrolleot">EOT</th>}
                                                            {emergencyOTEnabled && shiftDifferentialEnabled && <th className="payrolleotsd">EOTSD</th>}

                                                            {premiumEnabled && <th className="payrollpr">PR</th>}
                                                            {premiumEnabled && shiftDifferentialEnabled && <th className="payrollprsd">PRSD</th>}

                                                            {doubleTimeEnabled && <th className="payrolldt">DT</th>}
                                                            {doubleTimeEnabled && shiftDifferentialEnabled && <th className="payrolldtsd">DTSD</th>}


                                                            {Boolean(tenantSettings.enablePrevailingWageContracts) && (
                                                                <>
                                                                    <th className="payrollpw">PW</th>
                                                                    <th className="payrollpwot">
                                                                        PWOT
                                                                    </th>
                                                                    <th className="payrollpwt15">
                                                                        PWT15
                                                                    </th>
                                                                </>
                                                            )}

                                                            <th className="payrollbillable">
                                                                Billable
                                                            </th>
                                                            <th className="payrollbreak">
                                                                Break
                                                            </th>
                                                            <th className="payrollCurrent">
                                                                Current
                                                            </th>
                                                            {!!tenantSettings.timesheetAdjustmentsEnabled && (
                                                                <Can
                                                                    do="accept"
                                                                    on="timesheet"
                                                                >
                                                                    <th className="payrolldelete" />
                                                                </Can>
                                                            )}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {!(payroll.payrollCalculations ?? []).length ? (
                                                            <tr>
                                                                <td
                                                                    colSpan="5"
                                                                    className="text-center"
                                                                >
                                                                    No payroll found.
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            payroll.payrollCalculations.map(
                                                                (detail) => (
                                                                    <tr
                                                                        key={detail.id}
                                                                        className={`timesheet-payroll-table-row${detail.removed
                                                                            ? ' strikeout'
                                                                            : ''
                                                                            }`}
                                                                    >
                                                                        {!!tenantSettings.timesheetAdjustmentsEnabled && (
                                                                            <td className="isadjusted">
                                                                                {!!detail.isAdjustment && (
                                                                                    <Badge className="p-1">
                                                                                        ADJ
                                                                                    </Badge>
                                                                                )}
                                                                            </td>
                                                                        )}
                                                                        <td className="payrollcharge">
                                                                            {
                                                                                detail.chargeTypeName
                                                                            }
                                                                        </td>
                                                                        <td className="payrollname">
                                                                            {
                                                                                detail.employeeName
                                                                            }
                                                                        </td>
                                                                        <td className="payrollnote">
                                                                            {!!detail.note && (
                                                                                <div className="userNote">
                                                                                    <div className="noteContent">
                                                                                        {
                                                                                            detail.note
                                                                                        }
                                                                                    </div>
                                                                                    <div className="noteContentByLine">
                                                                                        {`${detail.noteAuthor}, ${moment.utc(detail.noteAdjustedOn).local().fromNow()}`}
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </td>
                                                                        <td className="payrollcharge">
                                                                            {parseFloat(
                                                                                detail.charge,
                                                                            ).toFixed(2)}
                                                                        </td>
                                                                        <td className="payrollpay">
                                                                            {parseFloat(
                                                                                detail.pay,
                                                                            ).toFixed(2)}
                                                                        </td>
                                                                        <td className="payrollreg">
                                                                            {parseFloat(
                                                                                detail.reg,
                                                                            ).toFixed(2)}
                                                                        </td>

                                                                        {shiftDifferentialEnabled && (
                                                                            <td className="payrollrsd">
                                                                                {parseFloat(
                                                                                    detail.rsd,
                                                                                ).toFixed(2)}
                                                                            </td>
                                                                        )}

                                                                        <td className="payrollot">
                                                                            {parseFloat(
                                                                                detail.ot,
                                                                            ).toFixed(2)}
                                                                        </td>

                                                                        {shiftDifferentialEnabled && (
                                                                            <td className="payrollotsd">
                                                                                {parseFloat(
                                                                                    detail.otsd,
                                                                                ).toFixed(2)}
                                                                            </td>
                                                                        )}

                                                                        <td className="payrollt15">
                                                                            {parseFloat(
                                                                                detail.t15,
                                                                            ).toFixed(2)}
                                                                        </td>

                                                                        {shiftDifferentialEnabled && (
                                                                            <td className="payrollt15SD">
                                                                                {parseFloat(
                                                                                    detail.t15SD,
                                                                                ).toFixed(2)}
                                                                            </td>
                                                                        )}

                                                                        {quirksDisabled && (
                                                                            <td className="payrollemg">
                                                                                {parseFloat(
                                                                                    detail.emg,
                                                                                ).toFixed(2)}
                                                                            </td>
                                                                        )}

                                                                        {quirksDisabled && shiftDifferentialEnabled && (
                                                                            <td className="payrollesd">
                                                                                {parseFloat(
                                                                                    detail.esd,
                                                                                ).toFixed(2)}
                                                                            </td>
                                                                        )}

                                                                        {emergencyOTEnabled && (
                                                                            <td className="payrolleot">
                                                                                {parseFloat(
                                                                                    detail.eot,
                                                                                ).toFixed(2)}
                                                                            </td>
                                                                        )}

                                                                        {emergencyOTEnabled && shiftDifferentialEnabled && (
                                                                            <td className="payrolleotsd">
                                                                                {parseFloat(
                                                                                    detail.eotsd,
                                                                                ).toFixed(2)}
                                                                            </td>
                                                                        )}

                                                                        {premiumEnabled && (
                                                                            <td className="payrollpr">
                                                                                {parseFloat(
                                                                                    detail.pr,
                                                                                ).toFixed(2)}
                                                                            </td>
                                                                        )}

                                                                        {premiumEnabled && shiftDifferentialEnabled && (
                                                                            <td className="payrollprsd">
                                                                                {parseFloat(
                                                                                    detail.prsd,
                                                                                ).toFixed(2)}
                                                                            </td>
                                                                        )}

                                                                        {doubleTimeEnabled && (
                                                                            <td className="payrolldt">
                                                                                {parseFloat(
                                                                                    detail.dt,
                                                                                ).toFixed(2)}
                                                                            </td>
                                                                        )}

                                                                        {doubleTimeEnabled && shiftDifferentialEnabled && (
                                                                            <td className="payrolldtsd">
                                                                                {parseFloat(
                                                                                    detail.dtsd,
                                                                                ).toFixed(2)}
                                                                            </td>
                                                                        )}

                                                                        {Boolean(tenantSettings.enablePrevailingWageContracts) && (
                                                                            <>
                                                                                <td className="payrollpw">
                                                                                    {parseFloat(
                                                                                        detail.pw,
                                                                                    ).toFixed(2)}
                                                                                </td>
                                                                                <td className="payrollpwot">
                                                                                    {parseFloat(
                                                                                        detail.pwot,
                                                                                    ).toFixed(2)}
                                                                                </td>
                                                                                <td className="payrollpwt15">
                                                                                    {parseFloat(
                                                                                        detail.pwT15,
                                                                                    ).toFixed(2)}
                                                                                </td>
                                                                            </>
                                                                        )}

                                                                        <td className="payrollbillable">
                                                                            {
                                                                                detail.billable
                                                                            }
                                                                        </td>
                                                                        <td className="payrollbreak">
                                                                            {Boolean(detail.isBreak) && (
                                                                                <>
                                                                                    {detail.isPaidBreak
                                                                                        ? 'Paid'
                                                                                        : 'Unpaid'}
                                                                                </>
                                                                            )}
                                                                        </td>
                                                                        <td className="payrollcurrent">
                                                                            {detail.current
                                                                                ? 'Yes'
                                                                                : 'No'}
                                                                        </td>
                                                                    </tr>
                                                                ),
                                                            )
                                                        )}
                                                    </tbody>
                                                </>
                                            )}

                                        </>
                                    )}
                                </table>
                            )}
                    </div>
                </UncontrolledCollapseUnderlineHeader>
            </SlideForm>
        );
    }
}
